import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./features/home/home.component').then(m => m.HomeComponent),
    title: 'Medicvoy | Premium Dental Care, Made Affordable'
  },
  {
    path: 'about',
    loadComponent: () =>
      import('./features/about/about.component').then(m => m.AboutComponent),
    title: 'About Us | Medicvoy'
  },
  {
    path: 'blog',
    loadComponent: () =>
      import('./features/blog/blog-list.component').then(m => m.BlogListComponent),
    title: 'Blog | Medicvoy'
  },
  {
    path: 'blog/:slug',
    loadComponent: () =>
      import('./features/blog/blog-detail/blog-detail.component').then(m => m.BlogDetailComponent),
    title: 'Blog | Medicvoy'
  },
  {
    path: 'partners',
    loadComponent: () =>
      import('./features/destinations/partner-clinics/partner-clinics.component').then(m => m.PartnerClinicsComponent),
    title: 'Partners | Medicvoy'
  },
  {
    path: 'destinations',
    loadComponent: () =>
      import('./features/destinations/destinations-list/destinations-list.component').then(m => m.DestinationsListComponent),
    title: 'Destinations | Medicvoy'
  },
  {
    path: 'destinations/:citySlug',
    loadComponent: () =>
      import('./features/destinations/city-detail/city-detail.component').then(m => m.CityDetailComponent),
    title: 'Destination | Medicvoy'
  },
  {
    path: 'destinations/:citySlug/:clinicSlug',
    loadComponent: () =>
      import('./features/destinations/clinic-detail/clinic-detail.component').then(m => m.ClinicDetailComponent),
    title: 'Clinic | Medicvoy'
  },
  {
    path: 'services',
    loadComponent: () =>
      import('./features/services/services-list/services-list.component').then(m => m.ServicesListComponent),
    title: 'Services | Medicvoy'
  },
  {
    path: 'services/:slug',
    loadComponent: () =>
      import('./features/services/service-detail/service-detail.component').then(m => m.ServiceDetailComponent),
    title: 'Service | Medicvoy'
  },
  {
    path: 'terms-and-conditions',
    loadComponent: () =>
      import('./features/legal/legal-page.component').then(m => m.LegalPageComponent),
    title: 'Terms & Conditions | Medicvoy',
    data: { slug: 'terms-and-conditions' }
  },
  {
    path: 'privacy-policy',
    loadComponent: () =>
      import('./features/legal/legal-page.component').then(m => m.LegalPageComponent),
    title: 'Privacy Policy | Medicvoy',
    data: { slug: 'privacy-policy' }
  },
  {
    path: 'accessibility-statement',
    loadComponent: () =>
      import('./features/legal/legal-page.component').then(m => m.LegalPageComponent),
    title: 'Accessibility Statement | Medicvoy',
    data: { slug: 'accessibility-statement' }
  },
  {
    path: 'refund-policy',
    loadComponent: () =>
      import('./features/legal/legal-page.component').then(m => m.LegalPageComponent),
    title: 'Refund Policy | Medicvoy',
    data: { slug: 'refund-policy' }
  },
  {
    path: 'contact',
    loadComponent: () =>
      import('./features/contact/contact.component').then(m => m.ContactComponent),
    title: 'Contact | Medicvoy'
  },
  {
    // Unknown addresses show the branded 404 page instead of silently
    // landing on the homepage (MV-030, US-060).
    path: '**',
    loadComponent: () =>
      import('./shared/components/not-found/not-found.component').then(m => m.NotFoundComponent),
    title: 'Page not found | Medicvoy'
  }
];
